<app-progress-dashboard-container [label]="label()">
  <div class="w-full h-[300px] flex justify-center items-stretch">
    <p-chart
      [type]="type()"
      [data]="data()"
      [options]="options()"
      class="w-full h-[300px] items-stretch"
      style="width: 100%; height: 100%; display: block"
    />
  </div>
</app-progress-dashboard-container>
